import { bindCreateAsyncThunkToState } from '@op/services'
import type { RootState } from './reducers/rootReducer'

export const createAsyncThunk = bindCreateAsyncThunkToState<RootState>()
